'use client';

import { useParams, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { usePromoCode } from '@/hooks/use-promo-code';
import { useTrackingCode } from '@/hooks/use-tracking-code';

function sanitizeRedirect(redirect: string | null) {
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return redirect;
  }

  return '/';
}

export default function PromoPage() {
  const params = useParams();
  const searchParams = useSearchParams();
  const { isReady: isPromoReady, setCode } = usePromoCode();
  const { isReady: isTrackingReady, setTracking } = useTrackingCode();

  useEffect(() => {
    const forwardedParams = new URLSearchParams(searchParams.toString());

    forwardedParams.delete('redirect');

    const path = sanitizeRedirect(searchParams.get('redirect'));
    const query = forwardedParams.toString();
    const redirectUrl = query ? `${path}?${query}` : path;
    const code = params?.code;
    const tracking = searchParams.get('tracking');

    if (typeof tracking === 'string' && isTrackingReady) {
      setTracking(tracking);
    }

    if (typeof code === 'string' && isPromoReady) {
      setCode(code).then(async () => {
        window.location.href = redirectUrl;
      });
    } else if (isPromoReady) {
      window.location.href = redirectUrl;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPromoReady]);

  return null;
}
